import React, { Component } from "react";
import ArenaDataService from "../services/arena.service";
import { withRouter } from '../common/with-router';
import { Link } from "react-router-dom";
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Breadcrumb from 'react-bootstrap/Breadcrumb';
import SponsorsList from "./sponsors-list.component";

class Arena extends Component {
  constructor(props) {
    super(props);
    this.getArena = this.getArena.bind(this);

    this.state = {
      arena: {},
      isLoading: true,
    };
  }

  componentDidMount() {
    this.getArena(this.props.router.params.id);
  }

  getArena(id) {
    ArenaDataService.get(id)
      .then(response => {
        this.setState({
          arena: response.data,
          isLoading: false,
        });
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  }

  render() {
    const { arena, isLoading } = this.state;

    return (
      <div className="mt-4">
        <Breadcrumb>
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>{arena.name}</Breadcrumb.Item>
        </Breadcrumb>

        <h4>{arena.name}</h4>
        {isLoading ? (
          <div className="text-center">
            <img src="/images/loading.svg" alt="Carregando..." />
          </div>
        ) : (
          <>
            <Row className="align-items-center">
              <Col className="col-6 col-md-4 col-lg-3 pb-4">
                <div>
                  <img src={`/logos/${arena.id}/logo.svg`} alt={`Logo`} height="105" />
                </div>
              </Col>
              <Col className="col-6 col-md-4 col-lg-3 pb-4">
                <div><span>{arena.city}-{arena.state}</span></div>
                <div><span>{arena.district}</span></div>
              </Col>
            </Row>
            <SponsorsList sponsors={arena.sponsors} arenaId={arena.id} />
            <Row>
              <Col className="col-12">
                <div className="places-title pb-4 pt-4">Escolha um local</div>
              </Col>
            </Row>
            <Row>
              {arena.places && arena.places.map((place, index) => (
                <Col key={index} className="col-12 col-md-4 col-lg-3 pb-4">
                  <Link to={`/arenas/${arena.id}/${arena.name}/${place.name}`}>
                    <Card className="flex-fill">
                      <Card.Body>
                        <Card.Title className="arena-place-name">{place.name}</Card.Title>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col>
              ))}
            </Row>
          </>
        )}
      </div>
    );
  }
}

export default withRouter(Arena);